/**
 * Column grid for the grant list. The LIST owns the tracks — the type label
 * takes the remainder, the Records and Write columns size to their widest
 * content across every row — and the header row, each group and each
 * GrantRow are subgrids of it, so cells align down the list like a table
 * without reserving fixed widths that would squeeze the label column to
 * nothing at the slideout's minimum (fixed 14rem + 7rem columns left it
 * 30px wide). The label column keeps an 8rem floor — checkbox plus
 * "Meeting Notes" — so the widest Records content ("Include everyone's
 * private" + toggle, ~208px) cannot starve it either; together with the
 * slideout's 560px minimum that floor is always satisfiable.
 *
 * All class strings are complete literals on purpose: Tailwind emits a
 * utility only for class names it finds verbatim in source, so a
 * template-built `grid-cols-[…${col}…]` compiles to nothing and the cells
 * stack.
 */
const LIST_WITH_WRITE = 'grid grid-cols-[minmax(8rem,1fr)_auto_auto] gap-x-4';
const LIST_READ_ONLY = 'grid grid-cols-[minmax(8rem,1fr)_auto] gap-x-4';
const ROW_WITH_WRITE = 'col-span-3 grid grid-cols-subgrid items-center';
const ROW_READ_ONLY = 'col-span-2 grid grid-cols-subgrid items-center';

/** The list container: defines the tracks every row shares. */
export function grantListGridClass(showWriteColumn: boolean): string {
  return showWriteColumn ? LIST_WITH_WRITE : LIST_READ_ONLY;
}

/** A full-width child of the list (header row, group, row): spans all tracks and inherits them. */
export function grantRowGridClass(showWriteColumn: boolean): string {
  return showWriteColumn ? ROW_WITH_WRITE : ROW_READ_ONLY;
}
